/* Step 8: Quebec Law 25 granular consent.
 * - Explicit opt-in (default OFF for analytics/marketing/functional).
 * - Stores choice in mb_consent_v2 cookie for 365 days.
 * - Activates "<script type='text/plain' data-consent='X'>" tags only when
 *   category X is granted. Use this pattern to gate GA / Meta Pixel / etc.
 * - Calls Shopify.customerPrivacy.setTrackingConsent so Shopify-owned
 *   pixels honor the choice too.
 */
(function () {
  'use strict';
  var COOKIE = 'mb_consent_v2';
  var TTL_DAYS = 365;
  var CATEGORIES = ['functional', 'analytics', 'marketing'];

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()\[\]\\\/\+^]/g, '\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function writeCookie(name, value, days) {
    var d = new Date(); d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }
  function loadConsent() {
    var raw = readCookie(COOKIE); if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }
  function saveConsent(state) {
    writeCookie(COOKIE, JSON.stringify(state), TTL_DAYS);
  }
  function applyShopify(state) {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
        Shopify.customerPrivacy.setTrackingConsent({
          analytics:    !!state.analytics,
          marketing:    !!state.marketing,
          preferences:  !!state.functional,
          sale_of_data: !!state.marketing
        }, function () {});
      }
    } catch (e) { /* Privacy API not present in all contexts */ }
  }
  function activateGated(state) {
    // Convert any <script type="text/plain" data-consent="cat">...</script>
    // into a real script tag if cat was granted.  Idempotent.
    var nodes = document.querySelectorAll('script[type="text/plain"][data-consent]');
    nodes.forEach(function (old) {
      var cat = old.getAttribute('data-consent');
      if (!state[cat]) return;
      var s = document.createElement('script');
      Array.prototype.slice.call(old.attributes).forEach(function (a) {
        if (a.name === 'type' || a.name === 'data-consent') return;
        s.setAttribute(a.name, a.value);
      });
      if (old.src) s.src = old.src; else s.text = old.textContent || '';
      old.parentNode.replaceChild(s, old);
    });
  }
  function dispatch(state) {
    document.dispatchEvent(new CustomEvent('consent:changed', { detail: state }));
  }
  function apply(state) {
    saveConsent(state);
    applyShopify(state);
    activateGated(state);
    dispatch(state);
  }

  function bindBanner() {
    var banner = document.getElementById('consent-banner');
    if (!banner) return;

    var prefsBox = banner.querySelector('[data-consent-prefs]');
    var prefInputs = banner.querySelectorAll('[data-consent-cat]');

    function setAllPrefs(v) { prefInputs.forEach(function (i) { i.checked = !!v; }); }
    function readPrefs() {
      var s = { essential: true };
      prefInputs.forEach(function (i) { s[i.getAttribute('data-consent-cat')] = i.checked; });
      return s;
    }
    function close() { banner.hidden = true; }

    banner.addEventListener('click', function (e) {
      var t = e.target.closest('[data-consent]'); if (!t) return;
      var act = t.getAttribute('data-consent');
      if (act === 'accept')    { setAllPrefs(true);  apply(readPrefs()); close(); }
      else if (act === 'reject')   { setAllPrefs(false); apply(readPrefs()); close(); }
      else if (act === 'customize'){ if (prefsBox) prefsBox.hidden = false; }
      else if (act === 'save-prefs'){ apply(readPrefs()); close(); }
    });

    var stored = loadConsent();
    if (stored) {
      apply(stored);  // re-activate gated scripts on every load
      return;         // banner stays hidden
    }
    banner.hidden = false;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-consent-open]');
    if (!t) return;
    e.preventDefault();
    var b = document.getElementById('consent-banner');
    if (b) {
      b.hidden = false;
      var prefs = b.querySelector('[data-consent-prefs]');
      if (prefs) prefs.hidden = false;
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindBanner);
  else bindBanner();
})();
